module.exports = __webpack_public_path__ + "img/2_uk.acd84793.svg";